import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';

const FichesInterventionsSettings = lazy(() =>
  import('@repo/ui/features/account/components/fiches-interventions-settings').then((mod) => ({ default: mod.FichesInterventionsSettings })),
);

export default function FichesInterventionsPage() {
  return (
    <div className="w-full py-6">
      <Suspense fallback={<DendromapLoader message="Chargement des fiches d'interventions..." />}>
        <FichesInterventionsSettings />
      </Suspense>
    </div>
  );
}

